/*
参数:
url: 播放地址
playerId: vido标签的id

注意：
Chrome 66之后的版本已经禁用了自动播放功能
* */

window.startPlay = function (url, playerId, auto) {
    if (auto == undefined) {
        auto = true;
    }
    var options = {
        width: "100%",
        height: "100%",
        fluid: false,
        language: "zh-CN",
        controls: true,
        autoplay: auto,
        loop: false,
        muted: false,
        sources: [],
        controlBar: {
            // 设置控制条组件
            // playToggle: true,
            // volumeMenuButton: true,
            // currentTimeDisplay: true,
            // timeDivider: true,
            // durationDisplay: true,
            // remainingTimeDisplay: true,
            // playbackRateMenuButton: true,
            children: [
                { name: "playToggle" }, // 播放/暂停按钮
                { name: "currentTimeDisplay" }, // 视频当前已播放时间
                { name: "progressControl" }, // 播放进度条
                { name: "durationDisplay" }, // 视频播放总时间
                { name: "timeDivider" }, // 分隔符
                { name: "remainingTimeDisplay" }, //  当前播放时间
                {
                    // 倍速播放
                    name: "playbackRateMenuButton",
                    playbackRates: [0.5, 1, 1.5, 2, 2.5],
                },
                {
                    name: "volumePanel", // 音量控制
                    inline: false, // 不使用水平方式
                },
                { name: "FullscreenToggle" }, // 全屏
            ],
        },
    };

    if (_.endsWith(url, ".m3u8")) {
        // options['techOrder'] = ['html5', 'flash'];
        // options['flash'] = {
        //     params: {
        //         wmode: 'Opaque'
        //     },
        //     swf: '/videojs/video-js.swf'
        // };
        options.sources = [
            {
                type: "application/x-mpegURL",
                src: url,
            },
        ];
    } else {
        if (_.startsWith(url, "rtmp://")) {
            options["techOrder"] = ["html5", "flash"];
            options["flash"] = {
                params: {
                    wmode: "Opaque",
                },
                swf: "/videojs/video-js.swf",
            };
            options.sources = [
                {
                    type: "rtmp/mp4",
                    src: url,
                },
            ];
        } else {
            options.sources = [
                {
                    type: "video/mp4",
                    src: url,
                },
            ];
        }
    }

    /* 请求m3u8文件时 避免缓存导致每一次获取的文件都是同一个 */
    videojs.Hls.xhr.beforeRequest = function (options) {
        options.uri = updateQueryStringParameter(
            options.uri,
            "_t",
            new Date().valueOf()
        );
        return options;
    };

    var player = videojs(playerId, options);

    player.ready(function () {});
    return player;
};

function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf("?") !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, "$1" + key + "=" + value + "$2");
    } else {
        return uri + separator + key + "=" + value;
    }
}
